export default __webpack_public_path__ + "static/media/waste_selected.1f460fae.svg";